export const allPermissions = [
  "management.view",
  "management.create",
  "management.update",
  "management.delete",
  "dashboard.view",
  "dashboard.create",
  "dashboard.update",
  "dashboard.delete",
  "leads.view",
  "leads.create",
  "leads.update",
  "leads.delete",
  "funnel.view",
  "funnel.create",
  "funnel.update",
  "funnel.delete",
];
